// extracted by mini-css-extract-plugin
module.exports = {"foursteps":"FourSteps_foursteps__3gEJ4","title":"FourSteps_title__2EDzz","step":"FourSteps_step__3t2ku"};